import { IconAlarm } from "@tabler/icons-react";
import { useMisEstadisticas } from "../hooks/use-mis-estadisticas";
import { StatCard } from "./StatCard";

/**
 * Insight crítico para el solicitante · solicitudes con plazo iniciado
 * (rechazo SAT previo) y le quedan ≤5 días al plazo de 15 días.
 *
 * Si no las atiende, Hangfire las marca DescartadaPorPlazoVencido y pierden
 * el trabajo previo. Por eso, cuando hay urgentes, el número DOMINA (token
 * `advertencia`) y la tarjeta entera navega a la lista filtrada por
 * "requieren revisión" — la urgencia se lee y se acciona en un clic.
 *
 * Reutiliza el átomo `StatCard` (misma anatomía y misma convención de
 * urgencia que los KPIs) en vez de reconstruir la tarjeta a mano.
 *
 * Decisión 19/63 · el plazo arranca con el PRIMER rechazo SAT y no se
 * reinicia con recargas posteriores.
 */
export function ProximasAVencerCard() {
  const { data, isPending } = useMisEstadisticas();
  const cantidad = data?.proximasAVencer ?? 0;
  const hayUrgentes = cantidad > 0;
  const esAutorizador = data?.audiencia === "Autorizador";
  const esVisor = data?.audiencia === "Visor";

  const hint = hayUrgentes
    ? esAutorizador
      ? "Autoriza antes que venza"
      : esVisor
        ? "Vencen en ≤5 días"
        : "Resuelve en menos de 5 días"
    : esAutorizador
      ? "Sin solicitudes urgentes en tu bandeja"
      : "Plazo de 15 días · ninguna urgente";

  return (
    <StatCard
      label="Próximas a vencer"
      value={String(cantidad)}
      hint={hint}
      icon={IconAlarm}
      color={hayUrgentes ? "advertencia" : "slate"}
      to={hayUrgentes ? (esAutorizador ? "/autorizacion/bandeja" : "/solicitudes") : undefined}
      search={hayUrgentes && !esAutorizador ? { filtro: "requierenAccion" } : undefined}
      loading={isPending}
    />
  );
}
